"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAccessTokenServer = exports.Endpoint = exports.API_PATHS = void 0;
exports.getUserFromToken = getUserFromToken;
exports.handleSocialLogin = handleSocialLogin;
exports.refreshTokenApiCall = void 0;
exports.refreshTokens = refreshTokens;
exports.userLogout = userLogout;
exports.userOTPLogin = userOTPLogin;
exports.userOTPRequest = userOTPRequest;
exports.userRegister = userRegister;
var _cookies = require("@kiwicom/cookies");
var _server = require("@kiwicom/cookies/server");
var _uuid = require("uuid");
var _config = _interopRequireDefault(require("../../../consts/config"));
var _headersV = require("../../fetch/headersV2");
var _User = require("../../../records/User");
var _handleAffiliateId = _interopRequireDefault(require("../../utils/handleAffiliateId"));
var _utils = require("../services/utils");
var session = _interopRequireWildcard(require("../../session/session"));
var _getTokenUserQuery = _interopRequireDefault(require("../../../graphql/account/queries/getTokenUserQuery"));
var _errors = require("../errors");
var _helpers = require("../helpers");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable */
// import { isWebview, isTequila } from "../platform/client";
// import { decodeJWT, isTokenValid, AsyncLock } from "./helpers";
// import { saveAuthTokens } from "./token";
// import { GET_ACCESS_TOKEN_FAILED, REFRESH_TOKENS_FAILED } from "../../consts/events";
// import type { $NitroEvent, Props as EventProps, Event } from "../../records/Event";
// import { server as serverLogger } from "../log/logger";
let Endpoint = exports.Endpoint = /*#__PURE__*/function (Endpoint) {
  Endpoint["PLEXUS"] = "plexus";
  Endpoint["TEQUILA"] = "tequila";
  return Endpoint;
}({});
const API_PATHS = exports.API_PATHS = {
  OTP_REQUEST: "v2/user/otp/request",
  OTP_LOGIN: "v2/user/otp/login",
  REGISTER: "v2/user/register",
  LOGOUT: "v2/me/logout",
  OAUTH_REDIRECT_URL: "v2/oauth/redirect-url",
  REFRESH: "v2/token/refresh"
};
const defaultRetryConfig = {
  maxRetries: 3,
  delayMs: 1000
};

// Promise cache variables
const refreshTokenLock = new _helpers.AsyncLock();
let refreshTokenPromise = null;
const mainAccessTokenLock = new _helpers.AsyncLock();
let mainAccessTokenPromise = null;

// Messages from different browsers on Network request cancellation
// https://request-cancellation-test.vercel.app/
const requestCancellationErrorMessages = ["Failed to fetch", "cancelled", "Load failed", "NetworkError when attempting to fetch resource."];
const delay = ms => new Promise(resolve => {
  setTimeout(resolve, ms);
});
async function handleAuthApiError(res) {
  const contentType = res.headers.get("content-type");
  const isErrorObject = contentType === null || contentType === void 0 ? void 0 : contentType.includes("application/problem+json");
  const errorData = await res.json();
  if (isErrorObject) {
    const apiError = errorData;
    throw new _errors.TokenRetrievalError(`${apiError.title}: ${apiError.detail} ${apiError.status}`, res.headers);
  }
  if (Array.isArray(errorData.detail)) {
    const validationError = errorData;
    const errorMessages = validationError.detail.map(err => `${err.msg} (${err.type}) at ${err.loc.join(".")}`);
    throw new _errors.UnauthorizedReasonError(`${_errors.ERROR_MESSAGES.VALIDATION}: ${errorMessages.join(", ")}`, res.headers);
  }
  throw new _errors.UnauthorizedReasonError(`${_errors.ERROR_MESSAGES.VALIDATION}: ${JSON.stringify(errorData.detail || errorData)}`, res.headers);
}
const makeRequest = async _ref => {
  let {
    url,
    headers,
    body,
    timeoutMs = 15000
  } = _ref;
  try {
    const res = await fetch(url, {
      method: "POST",
      headers: {
        ..._headersV.ANALYTICS_HEADERS,
        ...headers
      },
      body,
      signal: AbortSignal.timeout(timeoutMs)
    });
    if (!res.ok) {
      await handleAuthApiError(res);
    }

    // For 204 No Content or empty body responses
    if (res.body == null || res.status === 204) {
      return undefined;
    }
    return res.json();
  } catch (error) {
    if (error instanceof Error && error.name === "TimeoutError") {
      throw error;
    }
    throw error;
  }
};
function handleAuthApiResponse(userEndpoint, requestBody, options) {
  const retryConfig = {
    ...defaultRetryConfig,
    ...(options === null || options === void 0 ? void 0 : options.retryConfig)
  };
  const executeRequest = async function () {
    let currentKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    let attempt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    const idempotencyKey = attempt > 1 && currentKey ? currentKey : (0, _uuid.v4)();
    try {
      return await makeRequest({
        url: `${_config.default.apiAuthUrl}/${userEndpoint}`,
        headers: {
          ...(0, _headersV.getBasicHeaders)(),
          "X-Idempotency-Key": idempotencyKey
        },
        body: requestBody
      });
    } catch (error) {
      if (error instanceof TypeError && requestCancellationErrorMessages.includes(error.message)) {
        if (attempt < retryConfig.maxRetries) {
          await delay(retryConfig.delayMs);
          return executeRequest(idempotencyKey, attempt + 1);
        }
        throw new _errors.NetworkAbortError(`Request failed after ${attempt} attempts: ${error.message}`);
      }
      throw error;
    }
  };
  return executeRequest();
}
async function handleSocialAuthApiResponse(userEndpoint, provider, redirectUri, stateParams) {
  const headers = {
    ...(0, _headersV.getBasicHeaders)(),
    ..._headersV.ANALYTICS_HEADERS
  };
  const OAUTH_REDIRECT_URL_FULL_PATH = `${_config.default.apiAuthUrl}/${userEndpoint}?provider=${provider}&redirect_uri=${redirectUri}&state_params=${stateParams}`;
  const res = await fetch(OAUTH_REDIRECT_URL_FULL_PATH, {
    method: "POST",
    headers
  });
  if (!res.ok) {
    await handleAuthApiError(res);
  }
  const {
    redirect_uri
  } = await res.json();
  window.location.href = redirect_uri;
}
function userOTPRequest(input, retryConfig) {
  const requestBody = JSON.stringify({
    email: input.email,
    brand: input.brand
  });
  return handleAuthApiResponse(API_PATHS.OTP_REQUEST, requestBody, {
    retryConfig
  });
}
function userOTPLogin(input, retryConfig) {
  const requestBody = JSON.stringify({
    transaction_id: input.otpTransactionId,
    otp_code: input.otpCode
  });
  return handleAuthApiResponse(API_PATHS.OTP_LOGIN, requestBody, {
    retryConfig
  });
}
async function userLogout(token) {
  try {
    const response = await fetch(`${_config.default.apiAuthUrl}/v2/me/logout`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        ..._headersV.ANALYTICS_HEADERS
      }
    });
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response;
  } catch (error) {
    if (error instanceof TypeError && requestCancellationErrorMessages.includes(error.message)) {
      throw new _errors.NetworkAbortError(error.message);
    }
    throw error;
  }
}
function userRegister(input, retryConfig) {
  const requestBody = JSON.stringify({
    email: input.email,
    brand: input.brand,
    ...(input.properties && {
      properties: input.properties
    })
  });
  return handleAuthApiResponse(API_PATHS.REGISTER, requestBody, {
    retryConfig
  });
}
async function getUserFromToken(accessToken) {
  try {
    var _userData$data$viewer, _load;
    const res = await fetch(_config.default.accountApiUrl, {
      method: "POST",
      headers: {
        ..._headersV.JSON_BOTH,
        ..._headersV.ANALYTICS_HEADERS,
        Authorization: `Bearer ${accessToken}`
      },
      body: JSON.stringify({
        query: _getTokenUserQuery.default
      })
    });
    const userData = await res.json();
    if (!userData.data) {
      throw new _errors.TokenRetrievalError(_errors.ERROR_MESSAGES.TOKEN_RETRIEVAL);
    }
    if (((_userData$data$viewer = userData.data.viewer) === null || _userData$data$viewer === void 0 ? void 0 : _userData$data$viewer.__typename) === "Unauthorized") {
      throw new _errors.UnauthorizedReasonError(userData.data.viewer.reason);
    }
    const user = await (0, _User.mapAccountUser)(userData.data);
    (0, _handleAffiliateId.default)(user.affiliateId);
    (0, _utils.identifyExponeaUser)(user.email, (_load = (0, _cookies.load)(_cookies.Cookie.USER_ID)) !== null && _load !== void 0 ? _load : "");
    session.save(_cookies.SessionStorage.ACCOUNT_ID, user.id);
    session.save(_cookies.SessionStorage.EMAIL, user.email);
    return {
      type: "user",
      user,
      token: accessToken
    };
  } catch (error) {
    if (error instanceof TypeError && requestCancellationErrorMessages.includes(error.message)) {
      throw new _errors.NetworkAbortError(_errors.ERROR_MESSAGES.NETWORK_ABORT);
    }
    if (error instanceof _errors.TokenRetrievalError || error instanceof _errors.UnauthorizedReasonError) {
      throw error;
    }
    throw new _errors.TokenRetrievalError(_errors.ERROR_MESSAGES.API_ERROR);
  }
}
async function handleSocialLogin(provider, stateParams) {
  try {
    await handleSocialAuthApiResponse(API_PATHS.OAUTH_REDIRECT_URL, provider, _config.default.accountOAuthRedirectUrl, stateParams);
  } catch (error) {
    if (error instanceof TypeError && requestCancellationErrorMessages.includes(error.message)) {
      throw new _errors.NetworkAbortError(error.message);
    }
    throw error;
  }
}
const refreshTokenApiCall = async refreshToken => {
  try {
    return await handleAuthApiResponse(API_PATHS.REFRESH, JSON.stringify({
      refresh_token: refreshToken
    })).then(res => ({
      accessToken: res.token.access_token,
      refreshToken: res.token.refresh_token
    }));
  } catch (error) {
    if (error instanceof TypeError && requestCancellationErrorMessages.includes(error.message)) {
      throw new _errors.NetworkAbortError(_errors.ERROR_MESSAGES.NETWORK_ABORT);
    }
    throw new _errors.TokenRetrievalError(_errors.ERROR_MESSAGES.TOKEN_REFRESH_FAILED);
  }
};
exports.refreshTokenApiCall = refreshTokenApiCall;
async function refreshTokens(refreshToken) {
  // If a promise is already in progress, return it to avoid duplicate requests
  if (refreshTokenPromise) {
    return refreshTokenPromise;
  }

  // Try to acquire the lock
  try {
    await refreshTokenLock.acquire(10000, 30000);
  } catch (error) {
    throw new _errors.TokenRetrievalError(_errors.ERROR_MESSAGES.TOKEN_REFRESH_FAILED);
  }

  // Double-check if a promise was created by another call while we were getting the lock
  if (refreshTokenPromise) {
    refreshTokenLock.release();
    return refreshTokenPromise;
  }

  // Create the promise and store it
  refreshTokenPromise = (async () => {
    try {
      return await refreshTokenApiCall(refreshToken);
    } finally {
      // unset global var once the promise is completed
      setTimeout(() => {
        refreshTokenPromise = null;
      }, 0);
    }
  })();
  refreshTokenLock.release();
  return refreshTokenPromise;
}

// Validate JWT refresh token and decide if refresh tokens or sign-out
// const handleRefreshToken = async (refreshToken: string): Promise<string | null> => {
//   const decodedRefreshToken = decodeJWT(refreshToken);

//   // Check if the refresh token is valid
//   if (!decodedRefreshToken || !isTokenValid(decodedRefreshToken, 0)) {
//     return null; // Return null if the refresh token is invalid
//   }

//   try {
//     const tokens = await refreshTokens(refreshToken);
//     if (!tokens) {
//       remove(Cookie.SU_ACCESS_TOKEN);
//       remove(Cookie.SU_REFRESH_TOKEN);
//       return null;
//     }
//     saveAuthTokens(tokens);
//     return tokens.accessToken;
//   } catch (error) {
//     // Clear tokens on refresh failure
//     remove(Cookie.SU_ACCESS_TOKEN);
//     remove(Cookie.SU_REFRESH_TOKEN);
//     throw error;
//   }
// };

// const getAccessTokenWeb = async (): Promise<string | null> => {
//   const oldAccessToken = load(Cookie.UA_SESSION_TOKEN);

//   // Case: Old access token is present
//   if (oldAccessToken) {
//     remove(Cookie.UA_SESSION_TOKEN);
//     const tokens = await refreshTokens(oldAccessToken);
//     if (tokens) {
//       saveAuthTokens(tokens);
//       remove(Cookie.UA_SESSION_TOKEN);
//       return tokens.accessToken; // Return the access token if available
//     }
//   }

//   const accessToken = load(Cookie.SU_ACCESS_TOKEN);
//   const refreshToken = load(Cookie.SU_REFRESH_TOKEN);

//   // Case: Access token is present
//   if (accessToken) {
//     const decodedAccessToken = decodeJWT(accessToken);
//     const isAccessTokenValid = decodedAccessToken ? isTokenValid(decodedAccessToken, 60) : false;

//     // Case: Access token present and valid
//     if (isAccessTokenValid) {
//       return accessToken;
//     }
//   }

//   // Case: Access token present but expired/expiring
//   // Case: Access token is not present
//   if (refreshToken) {
//     // Validate and decide if refresh tokens or sign-out
//     return handleRefreshToken(refreshToken);
//   }

//   return null;
// };

// const getAccessTokenFromApp = async (forceRefresh = false): Promise<string | null> => {
//   try {
//     const availableMessages = await postMessageToMobileApp({
//       message: "availableMessages",
//       response: [] as string[],
//     });
//     // if provideAccessToken is not available, return null
//     if (!availableMessages?.includes("provideAccessToken")) {
//       return null;
//     }

//     const response = await postMessageToMobileApp<ProvideAccessToken>({
//       message: "provideAccessToken",
//       messagePayload: {
//         forceRefresh,
//       },
//       response: {
//         accessToken: "",
//       },
//     });
//     // Temporary fix to race condition issue found in @kiwicom/web-message-schemas
//     // Second call to provideAccessToken is needed to get access token
//     // TODO: Remove this once the issue is fixed in @kiwicom/web-message-schemas
//     if (response?.accessToken == null) {
//       const retryResponse = await postMessageToMobileApp<ProvideAccessToken>({
//         message: "provideAccessToken",
//         messagePayload: {
//           forceRefresh,
//         },
//         response: {
//           accessToken: "",
//         },
//       });
//       return retryResponse.accessToken ?? null;
//     }
//     return response?.accessToken ?? null;
//   } catch (error) {
//     throw new Error("Failed to get access token from webview");
//   }
// };

// const getAccessTokenWebview = async (): Promise<string | null> => {
//   const oldAccessToken = load(Cookie.UA_SESSION_TOKEN);

//   // Case: Older versions of apps will still support UA_SESSION_TOKEN
//   if (oldAccessToken) {
//     return oldAccessToken;
//   }

//   const accessToken = await getAccessTokenFromApp();

//   // Case: Access token is present
//   if (accessToken) {
//     const decodedAccessToken = decodeJWT(accessToken);
//     const isAccessTokenValid = decodedAccessToken ? isTokenValid(decodedAccessToken, 60) : false;

//     // Case: Access token present and valid
//     if (isAccessTokenValid) {
//       return accessToken;
//     }

//     return getAccessTokenFromApp(true);
//   }
//   return null;
// };

// type ErrorLogger = (event: $NitroEvent, options: { message: string }) => void;

// const logError = (error: unknown, logger: ErrorLogger = serverLogger): void => {
//   if (!logger) {
//     return;
//   }

//   if (error instanceof TokenRetrievalError) {
//     logger(REFRESH_TOKENS_FAILED, { message: error.message });
//     return;
//   }

//   if (error instanceof Error) {
//     logger(GET_ACCESS_TOKEN_FAILED, { message: error.message });
//     return;
//   }

//   logger(GET_ACCESS_TOKEN_FAILED, { message: "Unknown error occurred during token retrieval" });
// };

// type GetAccessTokenArgs = {
//   isSkyUsersV2?: boolean;
//   log?: (ev: Event, props: EventProps) => Promise<void>;
// };

// export const getAccessToken = async ({
//   isSkyUsersV2,
//   log,
// }: GetAccessTokenArgs): Promise<string | null> => {
//   const isTequilaEnabled = isTequila();

//   if (isTequilaEnabled) {
//     return load(Cookie.UA_SESSION_TOKEN) ?? null;
//   }
//   if (!isSkyUsersV2) {
//     return load(Cookie.UA_SESSION_TOKEN);
//   }

//   // If a promise is already in progress, return it to avoid duplicate requests
//   if (mainAccessTokenPromise) {
//     return mainAccessTokenPromise;
//   }

//   // Try to acquire the lock
//   try {
//     await mainAccessTokenLock.acquire(10000, 30000);
//   } catch (error) {
//     throw new TokenRetrievalError(ERROR_MESSAGES.TOKEN_REFRESH_FAILED);
//   }

//   // Double-check if a promise was created by another call while we were getting the lock
//   if (mainAccessTokenPromise) {
//     mainAccessTokenLock.release();
//     return mainAccessTokenPromise;
//   }

//   mainAccessTokenPromise = (async () => {
//     try {
//       if (isWebview()) {
//         return await getAccessTokenWebview();
//       }
//       return await getAccessTokenWeb();
//     } catch (error) {
//       logError(error, log);
//       return null;
//     } finally {
//       // unset global var once the promise is completed
//       setTimeout(() => {
//         mainAccessTokenPromise = null;
//       }, 0);
//     }
//   })();

//   mainAccessTokenLock.release();

//   return mainAccessTokenPromise;
// };

// export const isLoggedIn = async (): Promise<boolean> => {
//   const oldAccessToken = load(Cookie.UA_SESSION_TOKEN);

//   if (oldAccessToken) {
//     return true;
//   }

//   if (isWebview()) {
//     const accessToken = await getAccessTokenFromApp().catch(() => {
//       serverLogger(GET_ACCESS_TOKEN_FAILED, { message: "Failed to get access token from webview" });
//       return false;
//     });
//     return Boolean(accessToken);
//   }
//   const accessToken = load(Cookie.SU_ACCESS_TOKEN);
//   const decodedAccessToken = accessToken ? decodeJWT(accessToken) : null;
//   const isAccessTokenValid = decodedAccessToken ? isTokenValid(decodedAccessToken, 60) : false;
//   return Boolean(isAccessTokenValid);
// };

const getAccessTokenServer = req => {
  /* eslint-disable */
  if (!req) {
    return null;
  }
  // TEMP: Will be removed after SkyUsersV2 is fully implemented
  const oldAccessToken = (0, _server.load)({
    key: _cookies.Cookie.UA_SESSION_TOKEN,
    req
  });
  if (oldAccessToken !== null) {
    return oldAccessToken;
  }
  const accessToken = (0, _server.load)({
    key: _cookies.Cookie.SU_ACCESS_TOKEN,
    req
  });
  if (accessToken !== null) {
    return accessToken;
  }
  return null;
};
exports.getAccessTokenServer = getAccessTokenServer;